export default __webpack_public_path__ + "static/media/LaptopStand_Orange.728ad740.png";